<script>
	import { Router, Link, Route } from "svelte-routing";
	import Preload from "./components/Preload.svelte";
	import List from "./routes/List.svelte";
	import Vcard from "./routes/Vcard.svelte";
	import Maps from "./routes/Maps.svelte";
	import Notfound from "./routes/Notfound.svelte";
	let indexPersona;
	
	export let empleados;
</script>

<Router >
	<Preload />
	<main>
		<div class="body">
			<Route path="/card/:indexPersona" let:params>
				<Vcard {empleados} indexPersona="{params.indexPersona}" />
			</Route>
			<Route path="/maps/:indexPersona" let:params>
				<Maps {empleados} indexPersona="{params.indexPersona}" />
			</Route>
			<Route path="/">
				<List {empleados} bind:indexPersona={indexPersona}/>
			</Route>
		</div>
		<Route component="{Notfound}" />	
	</main>
</Router>

<style lang="scss">
.body{
	box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.8);
	color: var(--blue-dark);
	max-width: 450px;
	margin: 0 auto;
}
</style>